<template>
  <div class="container-fluid border-0 mb-0 shadow-none projectGantt pb-5 px-0">
    <portal to="sidebar">
      <rates
        :show="showRates"
        @outSideClicked="showRates = false"
        :fullWidth="false"
        @rateSelected="onRateSelected"
        :project="project"
        :task="selectedTask"
      />
    </portal>

    <portal to="sidebar" v-if="showRequirement">
      <requirement
        :show="showRequirement"
        @outSideClicked="showRequirement = false"
        :fullWidth="false"
        :project="project"
        :editId="(selectedTask || {}).id"
        @taskCreated="(showRequirement = false), $emit('taskCreated')"
      />
    </portal>

    <portal to="sidebar" v-if="project && showFinance">
      <finance
        :show="showFinance"
        @outSideClicked="showFinance = false"
        :fullWidth="false"
        :project="project"
        :task="selectedTask"
        @paymentSuccess="_onPaymentSuccess"
      />
    </portal>

    <user-picker-modal
      :_key="0"
      :visible="modals.contributors"
      modal-title="Key People"
      role="CONTRIBUTOR"
      :multi="true"
      v-model="contributors"
      :skipList="skipList"
      @input="_onContributerUsersChanged"
      @closeClicked="modals.contributors = false"
      :saveOnUserSelect="false"
      :defaults="[project.user_owner]"
    />

    <user-picker-modal
      :_key="1"
      :visible="modals.viewers"
      modal-title="Watchers"
      role="VIEWER"
      :multi="true"
      v-model="viewers"
      :skipList="skipList"
      @input="_onViewersChanged"
      @closeClicked="modals.viewers = false"
      :saveOnUserSelect="false"
    />

    <user-picker-modal
      :_key="2"
      :visible="modals.approvers"
      modal-title="Approvers"
      role="APPROVER"
      :multi="true"
      v-model="approvers"
      :skipList="skipListApprovers"
      @input="_onApproversChanged"
      @closeClicked="modals.approvers = false"
      :saveOnUserSelect="false"
    />

    <user-picker-modal
      :_key="3"
      :visible="modals.projectApprovers"
      modal-title="Approvers"
      role="APPROVER"
      :multi="true"
      v-model="projectApprovers"
      :skipList="skipListProjectApprovers"
      @input="_onProjectApproversChanged"
      @closeClicked="modals.projectApprovers = false"
      :saveOnUserSelect="false"
    />

    <div class="card card-table shadow-sm border-0 rounded-0">
      <div class="card-header border-bottom-0 d-flex justify-content-between">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="text-warning mb-0 pr-2">Status</h6>
          <!-- <el-select v-model="filter.status" class="select-danger " placeholder="" @change="onFilterChanged">
            <el-option v-for="option in ['All', 'Draft', 'Quoted', 'Approved']" :value="option" :label="option"
              :key="option" class="select-danger" />
          </el-select> -->

          <div
            class="d-flex flex-row justify-content-between align-items-center"
          >
            <base-radio
              name="All"
              class="mr-3"
              v-model="filter.status"
              @click="onFilterChanged"
            >
              All
            </base-radio>

            <!-- <base-radio name="Draft" class="mr-3" v-model="filter.status" @click="onFilterChanged">
                Draft
            </base-radio> -->

            <base-radio
              name="Quoted"
              class="mr-3"
              v-model="filter.status"
              @click="onFilterChanged"
            >
              Quoted
            </base-radio>

            <base-radio
              name="Approved"
              class="mr-3"
              v-model="filter.status"
              @click="onFilterChanged"
            >
              Approved
            </base-radio>
          </div>
        </div>

        <ul class="pl-0 mb-0 d-flex mr-2 font-size-zero">
          <li class="mr-4 font-size-zero d-inline-flex align-items-center">
            <a
              v-tooltip.top-center="`Approvers`"
              href="javascript:void(0)"
              @click="modals.projectApprovers = true"
              class="d-inline-block icn-notification position-relative font-size-zero lh-1"
            >
              <span class="icn-svg icn-key lh-1 test22">
                <svg
                  class="icn-svg-full"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  style="enable-background: new 0 0 20 20"
                  xml:space="preserve"
                >
                  <path
                    d="M10 0c-.2 0-.3 0-.3.1-.1 0-.1.1-.2.1-.2 0-.3.1-.4.2-.3.1-.7.4-1 .6l-1 .6c-.1.1-.3.1-.4.2h-.1c.1 0 .1 0 0 0s-.1 0 0 0h-.1l-.3.2-1.2.2c-.4.1-.8.2-1.1.3-.2.1-.4.1-.6.2-.1 0-.1 0-.3.2-.2.2-.2.3-.3.3 0 .2-.1.4-.2.7-.1.3-.2.7-.3 1.1L2 6.1c0 .1-.1.3-.1.4v.1c0-.1 0-.1 0 0s0 .1 0 0c-.1.1-.2.3-.3.4L1 8c-.2.4-.4.7-.6 1-.1.2-.2.3-.2.4 0 .1-.1.1-.1.2-.1.1-.1.1-.1.4 0 .3 0 .3.1.4 0 .1.1.1.1.2.1.1.1.3.2.4.2.3.4.7.6 1l.6 1 .2.3v.1c0-.1 0-.1 0 0s0 .1 0 0v.1l.2.3.2 1.2c.1.4.2.8.3 1.1.1.2.1.4.2.6 0 .1 0 .1.2.3.2.2.2.2.3.2.2.1.4.1.6.2.3.1.7.2 1.1.3l1.2.3.4.1h.1c-.1 0-.1 0 0 0s.1 0 0 0c.1.1.3.2.4.3l1 .6c.4.2.7.4 1 .6.1.1.3.2.4.2.1 0 .1.1.2.1.1.1.1.1.4.1.3 0 .3 0 .4-.1.1 0 .1-.1.2-.1.1-.1.3-.1.4-.2.3-.2.7-.4 1-.6l1-.6.3-.2h.1c-.1 0-.1 0 0 0s.1 0 0 0h.1l.4-.1c.3-.1.7-.2 1.1-.3.4-.1.8-.2 1.1-.3.2-.1.4-.1.6-.2.1 0 .1 0 .3-.2.2-.2.2-.2.2-.3.1-.2.1-.4.2-.6.1-.3.2-.7.3-1.1L18 14l.1-.4v-.1c0 .1 0 .1 0 0s0-.1 0 0c.1-.1.2-.3.3-.4l.6-1c.2-.4.4-.7.6-1 .1-.1.2-.3.2-.4 0-.1.1-.1.1-.2s.1-.1.1-.4c0-.3 0-.3-.1-.4 0-.1-.1-.1-.1-.2-.1-.1-.1-.3-.2-.4-.2-.3-.4-.7-.6-1l-.6-1c-.1-.1-.1-.2-.2-.3v-.1c0 .1 0 .1 0 0s0-.1 0 0v-.1l-.2-.4-.2-1.2c-.1-.4-.2-.8-.3-1.1-.1-.2-.1-.4-.2-.6 0-.1 0-.1-.2-.3-.2-.2-.2-.2-.3-.2-.2-.1-.4-.1-.6-.2-.3-.1-.7-.2-1.1-.3L13.9 2c-.1 0-.3-.1-.4-.1h-.1c.1 0 .1 0 0 0s-.1 0 0 0c-.1-.1-.3-.2-.4-.3L12 1c-.4-.2-.7-.4-1-.6-.1-.1-.3-.2-.4-.2-.1 0-.1-.1-.2-.1-.1-.1-.1-.1-.4-.1zm0 1.8.1.1c.3.2.6.4 1 .6l1 .6.4.2c.1.1.1.1.3.2.2.1.2.1.3.1l.4.1 1.1.3c.4 0 .8.1 1.1.1h.1v.1c.2.4.3.8.4 1.2.1.4.2.8.3 1.1V7c0 .1 0 .1.1.3.1.2.1.2.2.3l.2.4.6 1c.2.3.4.7.6 1l.1.1c-.2.4-.4.7-.7 1.1l-.6 1c-.1.1-.2.2-.2.4-.1.1-.1.1-.2.3-.1.2-.1.2-.1.3l-.1.4-.3 1.1c-.1.4-.2.8-.3 1.1v.1h-.1c-.3.1-.7.2-1.1.3-.4.1-.8.2-1.1.3-.1 0-.3.1-.4.1-.1 0-.1 0-.3.1-.2.1-.2.1-.3.2-.1.1-.2.1-.4.2l-1 .6c-.3.2-.7.4-1 .6H10c-.4-.2-.7-.4-1.1-.7l-1-.6c-.1-.1-.2-.2-.4-.2-.1-.1-.1-.1-.3-.2-.2-.1-.2-.1-.3-.1-.1 0-.3-.1-.4-.1l-1.1-.3c-.4 0-.7-.1-1.1-.2h-.1v-.1c-.2-.4-.3-.8-.4-1.2l-.3-1.1c0-.1-.1-.3-.1-.4 0-.1 0-.1-.1-.3-.1-.2-.1-.2-.2-.3-.1-.1-.1-.2-.2-.4-.2-.3-.4-.6-.6-1-.2-.3-.4-.6-.6-1V10l.1-.1c.2-.3.4-.6.6-1l.6-1 .2-.4c.1-.1.1-.1.2-.3.1-.1.1-.2.1-.3l.1-.4.3-1.1c.1-.4.2-.8.2-1.1v-.1h.1c.4-.2.8-.3 1.2-.4.4-.1.8-.2 1.1-.3.1 0 .3-.1.4-.1.1 0 .1 0 .3-.1.2-.1.2-.1.3-.2l.4-.1 1-.6c.3-.2.6-.4 1-.6h.1zm3.6 4.6c-.2 0-.4.1-.6.3l-4 4.6-1.8-1.5c-.3-.3-.9-.3-1.2.1-.3.4-.3.9.1 1.2l2.4 2c.3.3.9.3 1.2-.1l4.6-5.2c.3-.3.3-.9-.1-1.2-.2-.1-.4-.2-.6-.2z"
                    style="fill: #5603ad"
                  />
                </svg>
              </span>
              <span class="icn-badge bg-info-two">{{
                (project.approvers && project.approvers.length) || 0
              }}</span>
            </a>
          </li>
          <li class="mr-4 font-size-zero d-inline-flex align-items-center">
            <a
              v-tooltip.top-center="`Key People`"
              href="javascript:void(0)"
              @click="modals.contributors = true"
              class="d-inline-block icn-notification position-relative font-size-zero lh-1"
            >
              <span class="icn-svg icn-key lh-1 te222y">
                <svg
                  class="icn-svg-full"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  viewBox="0 0 22.1 22.3"
                  style="enable-background: new 0 0 22.1 22.3"
                  xml:space="preserve"
                >
                  <path
                    fill="#2dce89"
                    d="M14 9.3c.6-2.1.3-4.3-.9-6.1C11.9 1.4 10 .2 7.8 0 5.7-.2 3.6.6 2.1 2.1S-.2 5.8 0 7.9C.2 10 1.3 12 3.1 13.2c1.8 1.2 4 1.5 6 .9l2.7 2.7c.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h3.9c.2 0 .3-.1.5-.2.1-.1.2-.3.2-.5v-3.9c0-.2-.1-.3-.2-.5l-7.9-8zM20.8 21h-2.6v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-1.9v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-2.3l-2.8-2.8c-.2-.2-.4-.2-.7-.2-1.7.6-3.5.4-5.1-.5-1.5-.9-2.5-2.5-2.7-4.3C1.1 6.1 1.8 4.3 3 3s3-1.9 4.8-1.7c1.8.2 3.4 1.2 4.3 2.8.9 1.5 1.1 3.4.5 5.1-.1.2 0 .5.2.7l8 8.1v3z"
                  />
                  <path
                    fill="#2dce89"
                    d="M4.3 4.7c-.4.4-.6.9-.6 1.5s.2 1.1.7 1.5c.4.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6.4-.4.7-.9.7-1.5s-.4-1.1-.8-1.5c-.5-.4-1-.6-1.6-.6-.6 0-1.1.2-1.6.6zm2.1 2c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1 .1-.1.3-.2.5-.2s.4.1.5.2c.2.1.2.3.2.5s0 .4-.2.5z"
                  />
                </svg>
              </span>
              <span class="icn-badge bg-success">{{
                (project.contributors && project.contributors.length + 1) || 0
              }}</span>
            </a>
          </li>
          <li class="font-size-zero lh-1 d-inline-flex align-items-center">
            <a
              v-tooltip.top-center="`Watchers`"
              href="javascript:void(0);"
              @click="modals.viewers = true"
              class="d-inline-block icn-notification position-relative font-size-zero lh-1"
            >
              <span class="icn-svg icn-eye font-size-zero lh-1">
                <svg
                  class="icn-svg-full"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  viewBox="0 0 28.1 18.2"
                  style="enable-background: new 0 0 28.1 18.2"
                  xml:space="preserve"
                >
                  <path
                    fill="#fb6340"
                    d="M14.3 18.2c4.8 0 9.5-3 13.7-8.8.1-.2.2-.5 0-.7-.2-.3-5.8-8.5-13.9-8.7C9.2-.1 4.5 2.8.1 8.7c-.1.2-.1.5 0 .7.2.4 5.8 8.7 13.9 8.9.1-.1.2-.1.3-.1zm12.5-9.1c-4 5.4-8.3 8.1-12.7 8-6.5-.1-11.5-6.4-12.7-8 4-5.3 8.3-7.9 12.7-7.9 6.5.2 11.5 6.3 12.7 7.9z"
                  />
                  <path
                    fill="#fb6340"
                    d="M14.1 14.1c1.3 0 2.6-.5 3.6-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.6-1.5s-2.6.5-3.6 1.5C9.6 6.5 9 7.8 9 9.1c0 1.3.5 2.6 1.5 3.5.9 1 2.2 1.5 3.6 1.5zm0-8.7c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7s-.4 2-1.1 2.7c-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1c-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1z"
                  />
                </svg>
              </span>
              <span class="icn-badge bg-alert">{{
                (project.viewers && project.viewers.length) || 0
              }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="card-body px-0 pt-0 pb-0">
        <div class="table-responsive p-0">
          <table
            class="table align-items-center justify-content-center mb-0 table-custom-one"
          >
            <thead>
              <tr>
                <!-- <th class="text-uppercase text-muted text-xxs font-weight-bold   ps-2 bg-light">
                  Status
                </th> -->

                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold bg-light text-center"
                  style="padding-right: 0px; padding-left: 0px"
                >
                  <div
                    class="d-flex justify-content-center align-items-center lh-1"
                  >
                    <!-- <span class="icn-svg icn-sorting ml-1 lh-1">
                      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" class="icn-svg-full"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M3.80439 0.203125L7.52283 4.58268H0.0859375L3.80439 0.203125ZM3.80439 11.152L0.0859375 6.77245H7.52283L3.80439 11.152Z"
                          fill="#8898AA" />
                      </svg>
                    </span> -->
                  </div>
                </th>

                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  <div
                    class="d-flex justify-content-start align-items-center lh-1"
                  >
                    Requirement
                    <span class="icn-svg icn-sorting ml-1 lh-1">
                      <svg
                        width="8"
                        height="12"
                        viewBox="0 0 8 12"
                        fill="none"
                        class="icn-svg-full"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.80439 0.203125L7.52283 4.58268H0.0859375L3.80439 0.203125ZM3.80439 11.152L0.0859375 6.77245H7.52283L3.80439 11.152Z"
                          fill="#8898AA"
                        />
                      </svg>
                    </span>
                  </div>
                </th>
                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  Rate
                </th>
                <th
                  v-if="profile.quoteCalculationInterval == 'DAY'"
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  Days
                </th>
                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  Team
                </th>
                <th
                  v-if="profile.quoteCalculationInterval == 'HOUR'"
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  Hours
                </th>

                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  Months
                </th>
                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  <div
                    class="d-flex justify-content-end align-items-center lh-1"
                  >
                    Cost
                    <!-- <span class="icn-svg icn-sorting ml-1">
                      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" class="icn-svg-full"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M3.80439 0.203125L7.52283 4.58268H0.0859375L3.80439 0.203125ZM3.80439 11.152L0.0859375 6.77245H7.52283L3.80439 11.152Z"
                          fill="#8898AA" />
                      </svg>
                    </span> -->
                  </div>
                </th>

                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  <div
                    class="d-flex justify-content-end align-items-center lh-1"
                  >
                    GST
                  </div>
                </th>

                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  <div
                    class="d-flex justify-content-end align-items-center lh-1"
                  >
                    Total
                  </div>
                </th>
                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  <div class="d-flex align-items-center">
                    <span>Description</span>
                    <label for="switchEOT" class="switch mb-0 mx-2">
                      <span class="icn-svg icn-switch ml-1">
                        <input
                          type="checkbox"
                          id="switchEOT"
                          v-model="expandedEOT"
                        />
                        <svg
                          width="140"
                          height="16"
                          viewBox="0 0 140 50"
                          class="icn-svg-full"
                        >
                          <rect
                            x="5"
                            y="-8"
                            rx="33"
                            width="134"
                            height="66"
                            stroke-width="0px"
                          ></rect>
                          <circle
                            cy="25"
                            fill="#ffffff"
                            stroke="black"
                            stroke-width="0px"
                            r="23"
                          ></circle>
                        </svg>
                      </span>
                    </label>
                    <span>Expand</span>
                  </div>
                </th>
                <th
                  v-if="false"
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light text-center"
                >
                  <div
                    class="d-flex justify-content-center align-items-center lh-1"
                  >
                    Approvees
                    <span class="icn-svg icn-sorting ml-1">
                      <svg
                        width="8"
                        height="12"
                        viewBox="0 0 8 12"
                        fill="none"
                        class="icn-svg-full"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.80439 0.203125L7.52283 4.58268H0.0859375L3.80439 0.203125ZM3.80439 11.152L0.0859375 6.77245H7.52283L3.80439 11.152Z"
                          fill="#8898AA"
                        />
                      </svg>
                    </span>
                  </div>
                </th>

                <th
                  class="text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light"
                >
                  <div
                    class="d-flex justify-content-center align-items-center lh-1"
                  >
                    Approve
                  </div>
                </th>
                <th class="bg-light"></th>
              </tr>
            </thead>
            <tbody v-if="openTasks">
              <tr
                v-for="(task, ind) in openTasks"
                :key="ind"
                @click="selectedTask = task"
                :style="{
                  background:
                    task.approval_status == 'QUOTED'
                      ? '#f2fff2'
                      : task.approval_status == 'APPROVED' &&
                        task.payment_status == 'OVERDUE'
                      ? '#faebeb'
                      : 'white'
                }"
              >
                <!-- <td>
                  <span>{{ task.approval_status.toProperCase() }}</span>
                </td> -->

                <td style="padding-right: 0px; padding-left: 0px">
                  <div
                    class="d-flex align-items-center justify-content-center tyyy"
                  >
                    <div>
                      <user-avatar-small
                        :data="task.assignedBy"
                        :disableEdit="true"
                      />
                    </div>
                  </div>
                </td>

                <td>
                  <!-- <a href="#" class="btn-link text-success"><span class="font-weight-bold">+ New Requirement</span></a> -->

                  <input
                    v-if="canEditDescription(task)"
                    class="form-control form-control--inside-tbl form-control--new-requirement w-100"
                    rows="3"
                    :placeholder="placeholder"
                    @focus="placeholder = ''"
                    @blur="_onDescriptionBlur(task)"
                    v-model="task.name"
                  />
                  <span v-else style="font-size: 0.74rem">{{ task.name }}</span>
                </td>

                <td>
                  <span
                    @click="
                      editIndex = ind;
                      showRates = canEdit(task);
                      selectedTask = task;
                    "
                    v-if="task.hourly_cost && task.hourly_cost != 0"
                    >{{ profile.currency && profile.currency.symbol
                    }}{{ task.hourly_cost }}
                    {{ profile.currency && profile.currency.value }}/HR</span
                  >
                  <button
                    v-else
                    @click="
                      editIndex = ind;
                      showRates = canEdit(task);
                      selectedTask = task;
                    "
                    class="btn btn-dot-action text-default border-0 mb-0 p-0"
                  >
                    <i aria-hidden="true" class="fa fa-ellipsis-h text-xs"></i>
                  </button>
                </td>
                <td v-if="profile.quoteCalculationInterval == 'DAY'">
                  <!-- <button  class="btn btn-dot-action text-default border-0  mb-0"><i  aria-hidden="true" class="fa fa-ellipsis-h text-xs"></i></button> -->
                  <input
                    v-if="canEdit(task)"
                    class="form-control form-control--inside-tbl form-control--input-width-small form-control--placeholder-text-lg"
                    v-model="task.no_of_days"
                    placeholder="..."
                    @blur="_updateTask(task)"
                  />
                  <span v-else>{{ task.no_of_days }}</span>
                </td>
                <td>
                  <!-- <el-select
                      v-model="task.total_team_members"
                      class="radius-0 select-small border-0"
                      size="small"
                      @change="saveTask(task)"
                    >
                      <el-option
                        v-for="option in [
                          5,
                          10,
                          15,
                          20,
                          25,
                          30,
                          35,
                          40,
                          45,
                          50,
                          55,
                          60,
                          65,
                          70,
                          75,
                          80,
                          85,
                          90
                        ]"
                        :value="option"
                        :label="option"
                        :key="option"
                        class="select-danger"
                      />
                    </el-select> -->
                  <input
                    v-if="canEdit(task)"
                    class="form-control form-control--inside-tbl form-control--input-width-small form-control--placeholder-text-lg"
                    v-model="task.total_team_members"
                    placeholder="..."
                  />
                  <span v-else>{{ task.total_team_members }}</span>
                </td>
                <td v-if="profile.quoteCalculationInterval == 'HOUR'">
                  <input
                    v-if="canEdit(task)"
                    class="form-control form-control--inside-tbl form-control--input-width-small"
                    rows="3"
                    v-model="task.quoted_hours"
                    @blur="_updateTask(task)"
                  />
                  <span v-else>{{ task.quoted_hours }}</span>
                </td>

                <td>
                  <!-- <input v-if="canEdit(task)" class="form-control form-control--inside-tbl form-control--input-width-small" rows="3"
                    v-model="task.mbs_months" @blur="_updateTask(task)" /> -->

                  <el-select
                    v-if="canEdit(task)"
                    v-model="task.mbs_months"
                    class="radius-0 select-small border-0 form-control--inside-tbl form-control--input-width-small"
                    size="small"
                    value-key="value"
                    @change="_updateTask(task)"
                  >
                    <el-option
                      v-for="(option, index) in [
                        { value: 1, label: '-' },
                        { value: 2, label: '2' },
                        { value: 3, label: '3' },
                        { value: 4, label: '4' },
                        { value: 5, label: '5' },
                        { value: 6, label: '6' },
                        { value: 7, label: '7' },
                        { value: 8, label: '8' },
                        { value: 9, label: '9' },
                        { value: 10, label: '10' },
                        { value: 11, label: '11' },
                        { value: 12, label: '12' }
                      ]"
                      :label="option.label"
                      :value="option.value"
                      :key="index"
                      class="select-danger"
                    />
                  </el-select>

                  <span v-else>{{
                    task.mbs_months < 2 ? "-" : task.mbs_months
                  }}</span>
                </td>

                <td class="text-right">
                  <span>{{ getTotalCost(task).costFormatted }}</span>
                </td>
                <td class="text-right">
                  <span>{{ getTotalCost(task).gstFormatted }}</span>
                </td>
                <td class="text-right">
                  <span>{{ getTotalCost(task).netTotalFormatted }}</span>
                </td>
                <td>
                  <span
                    class="font-weight-light d-block table-custom-one__content-wrap"
                  >
                    <textarea
                      v-if="canEditDescription(task)"
                      class="form-control form-control--inside-tbl w-100"
                      placeholder="Enter Description"
                      v-model="task.quoted_text"
                      @blur="_updateTask(task)"
                    ></textarea>
                    <span v-else>{{ task.quoted_text }}</span>
                  </span>
                </td>

                <td class="text-center" v-if="false">
                  <div class="comment-header__cc__ext pl-2 ml-1">
                    <div
                      class="avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-ext"
                    >
                      <a
                        v-for="(u, i) in task.approvers"
                        :key="i"
                        @click="
                          selectedTask = task;
                          modals.approvers = true;
                        "
                        href="javascript:void(0)"
                        class="to-2 avatar avatar-sm rounded-circle text-sm"
                        :class="userAvatar(u && u.user).bg"
                        data-toggle="tooltip"
                        :title="u.user.first_name + ' ' + u.user.last_name"
                        data-target="offcanvascced_int"
                        data-offcanvasfrom="offcanvas"
                      >
                        <span v-if="!userAvatar(u && u.user).hasImage">{{
                          userAvatar(u && u.user).avatar
                        }}</span>
                        <img
                          v-if="userAvatar(u && u.user).hasImage"
                          alt="Image placeholder"
                          :src="userAvatar(u && u.user).avatar"
                        />
                      </a>

                      <a
                        @click="_onAddApproverClicked(task)"
                        href="javascript:void(0)"
                        class="to-3 avatar avatar--38 rounded-circle"
                        data-toggle="tooltip"
                        title="Add User"
                        :class="
                          isApproverForTheTaskOrProject(task)
                            ? 'bg-success'
                            : 'bg-gray'
                        "
                        data-target="offcanvascced_int"
                        data-offcanvasfrom="offcanvas"
                      >
                        <i class="fas fa-plus text-xs"></i>
                      </a>
                    </div>
                  </div>
                </td>

                <td class="">
                  <div
                    class="d-flex justify-content-center align-items-center"
                    v-if="
                      task.approval_status == 'APPROVED' &&
                        task.payment_status == 'SUCCESS' &&
                        task.id
                    "
                  >
                    <!-- <base-checkbox
                      :checked="true" disabled class="adwe" /> -->

                    <span>Approved</span>
                  </div>

                  <div
                    class="d-flex justify-content-center align-items-center"
                    v-if="
                      task.approval_status == 'APPROVED' &&
                        task.payment_status == 'OVERDUE' &&
                        task.id
                    "
                  >
                    <!-- <base-checkbox
                      :checked="true" disabled class="adwe" /> -->

                    <span>Approved</span>
                    <a
                      v-if="isOverDue(task)"
                      v-tooltip.top-center="`This task is overdue`"
                      href="javascript:void(0);"
                      class="d-inline-block icn-notification position-relative font-size-zero lh-1 mb-2"
                      @click="_onInvoiceClicked(task)"
                    >
                      <span class="icn-badge bg-alert">1</span>
                    </a>
                  </div>

                  <div
                    v-if="
                      project.payment_status != 'SUCCESS' &&
                        task.approval_status != 'APPROVED' &&
                        ((task.approver &&
                          task.approvers.some(a => a.user.id == profile.id)) ||
                          (project.approvers &&
                            project.approvers.some(
                              a => a.user.id == profile.id
                            )))
                    "
                    class="d-flex justify-content-center align-items-center"
                  >
                    <base-checkbox
                      v-model="task.approval_checked"
                      class="adwe"
                    />
                  </div>

                  <!-- <base-checkbox
                    v-if="project.payment_status != 'SUCCESS' && task.approval_status != 'APPROVED' && ((task.approver && (task.approvers.some(a => a.user.id == profile.id))) || project.approvers && (project.approvers.some(a => a.user.id == profile.id)))"
                    v-model="task.approval_checked" class="te22" /> -->
                </td>
                <td class="text-right 33 d-flex justify-content-end">
                  <!-- <button class="border-0 p-0 bg-white btn-icn-dot" type="button ">
                                             <span class="icn-svg icn-v-dot">
                                               <svg xmlns="http://www.w3.org/2000/svg" class="icn-svg-full" viewBox="0 0 9 45" style="enable-background:new 0 0 9 45" xml:space="preserve"><path d="M0 0h9v9H0zM0 18h9v9H0zM0 36h9v9H0z"/></svg>
                                             </span>
                                            </button> -->

                  <!-- <badge v-if="isOverDue(task)" type="danger">Overdue</badge> -->

                  <base-dropdown
                    v-if="shouldShowMenu(task)"
                    :has-toggle="false"
                    title-classes="btn-dot-action text-default border-0  mb-0 mr-0"
                    class="dropdown--dot"
                    menu-on-right
                  >
                    <template slot="title">
                      <i class="fas fa-ellipsis-v text-xs" />
                    </template>

                    <div class="d-flex w-100">
                      <a
                        v-if="canDelete(task)"
                        class="dropdown-item d-flex alig-items-center lh-1"
                        href="javascript:void(0);"
                        @click="_onDeleteTaskClicked(task)"
                        ><i
                          class="fas fa-minus-circle mr-2 fas--sm text-danger"
                        ></i>
                        Delete</a
                      >
                      <a
                        v-if="isOverDue(task)"
                        class="dropdown-item d-flex alig-items-center lh-1"
                        href="javascript:void(0);"
                        @click="_onInvoiceClicked(task)"
                        ><i
                          class="fas fa-credit-card mr-2 fas--sm text-success"
                        ></i>
                        Update Billing</a
                      >
                    </div>
                  </base-dropdown>
                </td>
              </tr>

              <tr>
                <!-- <td class="align-middle">

                </td> -->

                <td colspan="6" class="align-middle">
                  <span class="font-weight-bold">Bracket Processing Fee</span>
                </td>
                <td class="text-right">
                  <span class="font-weight-bold"
                    >{{ selectedBudget.currency
                    }}{{ selectedBudget.bracketFeeFormatted }}</span
                  >
                </td>

                <td class="align-middle"></td>

                <td class="align-middle"></td>

                <td class="align-middle"></td>

                <td class="text-center" colspan="1"></td>

                <td class="align-middle"></td>
              </tr>

              <tr>
                <!-- <td class="align-middle">

                </td> -->

                <td colspan="12" class="align-middle">
                  <base-button
                    outline
                    type="success"
                    class="btn-sm"
                    @click="_onNewRequirementClicked"
                    v-if="isApproverForTheProject"
                  >
                    <!-- <i class="fa fa-plus" /> -->
                    + Add Task
                  </base-button>
                </td>
              </tr>

              <tr>
                <!-- <td class="align-middle">

                </td> -->

                <td colspan="6" class="align-middle">
                  <span class="font-weight-bold">Total</span>
                </td>
                <td class="text-right">
                  <span class="font-weight-bold"
                    >{{ projectBudget.currency }}{{ projectBudget.cost }}</span
                  >
                </td>
                <td class="align-middle"></td>

                <td class="align-middle"></td>
                <td class="align-middle"></td>

                <td class="text-center">
                  <base-checkbox
                    v-if="
                      project.payment_status == 'PENDING' &&
                        isApproverForTheProject
                    "
                    v-model="selectAll"
                    v-tooltip.center="`Approve`"
                  />
                </td>

                <td></td>
              </tr>

              <tr
                v-if="approvalSelectedTasks && approvalSelectedTasks.length > 0"
              >
                <!-- <td class="align-middle">

                </td> -->

                <td colspan="6" class="align-middle">
                  <span class="font-weight-bold">Approved</span>
                </td>
                <td class="text-right">
                  <span class="font-weight-bold"
                    >{{ selectedBudget.currency
                    }}{{ selectedBudget.cost }}</span
                  >
                </td>

                <td class="align-middle"></td>

                <td class="align-middle"></td>

                <td class="align-middle"></td>

                <td class="text-center" colspan="1"></td>

                <td class="align-middle"></td>
              </tr>

              <tr>
                <td class="text-right" colspan="11">
                  <base-button
                    size="sm"
                    @click="_onApproveClicked"
                    type="success"
                    v-if="
                      approvalSelectedTasks && approvalSelectedTasks.length > 0
                    "
                  >
                    Approve and Pay
                  </base-button>
                </td>

                <td class="text-center">&nbsp;</td>
              </tr>
            </tbody>
          </table>
          <div id="container-scroll"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import HtmlEditor from "../../components/Inputs/HtmlEditor.vue";
import UserAvatar from "./UserAvatar.vue";
import UserAvatarSmall from "./UserAvatarSmall.vue";
import AssetThread from "./AssetThread.vue";
import Rates from "./Rates.vue";
import Requirement from "./Requirement.vue";
import { isMobile } from "mobile-device-detect";
import UserPickerModal from "@/app/components/UserPickerModal.vue";
import moment from "moment";
import swal from "sweetalert2";
import Finance from "@/app/components/Finance.vue";
import numeral from "numeral";
let saving = false;

export default {
  props: ["tasks", "project"],
  components: {
    AssetThread,
    HtmlEditor,
    UserAvatar,
    UserAvatarSmall,
    UserPickerModal,
    Rates,
    Finance,
    Requirement
  },
  name: "TableView",
  data() {
    return {
      selectedTask: this.tasks.data[0] || null,
      isMobile: isMobile,
      editMode: false,
      newTasks: [],
      selectAll: false,
      modals: {
        contributors: false,
        viewers: false,
        approvers: false,
        projectApprovers: false
      },
      expanded: false,
      expandedEOT: true,
      placeholder: "+ New Requirement",
      showRates: false,
      showFinance: false,
      editIndex: 0,
      selectedTaskId: null,
      approvedTableExpanded: true,
      quotedTableExpanded: true,
      showRequirement: false,
      filter: { status: "All" }
    };
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("project", ["histories"]),
    ...mapState("common", ["roles"]),
    contributors: {
      get: function() {
        return this.project.contributors || [];
      },
      set: function(value) {
        this.setSingleProject({ ...this.project, contributors: value });
      }
    },

    viewers: {
      get: function() {
        return this.project.viewers || [];
      },
      set: function(value) {
        this.setSingleProject({ ...this.project, viewers: value });
      }
    },

    approvers: {
      get: function() {
        return (this.selectedTask || {}).approvers || [];
      },
      set: function(value) {
        this.selectedTask.approvers = value;
      }
    },

    projectApprovers: {
      get: function() {
        return this.project.approvers || [];
      },
      set: function(value) {
        this.project.approvers = value;
      }
    },

    skipList() {
      let arr = [...(this.contributors || []), ...(this.viewers || [])];
      if (this.project.user_owner) {
        arr.push(this.project.user_owner);
      }

      if (this.project.approver) {
        arr.push(this.project.approver);
      }

      if (this.project.financePayer) {
        arr.push(this.project.financePayer);
      }
      return [];
    },

    skipListApprovers() {
      let arr = [...((this.selectedTask || {}).approvers || [])];
      if (this.selectedTask && this.selectedTask.assignedBy) {
        arr.push(this.selectedTask.assignedBy);
      }

      if (this.selectedTask && this.selectedTask.assignedTo) {
        arr.push(this.selectedTask.assignedTo);
      }

      return arr;
    },

    skipListProjectApprovers() {
      let arr = [...(this.project.approvers || [])];
      if (this.project.user_owner) {
        arr.push(this.project.user_owner);
      }

      return arr;
    },

    isApproverForTheProject() {
      return this.project.approvers.some(c => c.user.id == this.profile.id);
    },

    openTasks() {
      let t =
        (this.tasks &&
          this.tasks.data.filter(t => {
            let cond = t.approval_status == this.filter.status.toUpperCase();
            console.log("open tasks", cond);
            console.log(t.mbs_months, "monthhhh");

            if (this.filter.status == "All") {
              cond =
                t.approval_status == "QUOTED" ||
                t.approval_status == "APPROVED" ||
                t.approval_status == "DRAFT";
            }

            return t.status != "CLOSED" && cond;
          })) ||
        [];

      //this.placeholder = this.isApproverForTheProject+" is "
      //disabled new task row for now
      if (!this.isApproverForTheProject) {
        t = [...t, ...this.newTasks];
      }
      console.log("Open tasks", t);

      return t;
    },

    approvalSelectedTasks() {
      let t = this.openTasks || [];
      if (t.length > 0) {
        return t.filter(t => {
          const isApprover = this.isApproverForTheTaskOrProject(t);
          return (
            isApprover &&
            t.approval_checked == true &&
            t.approval_status != "APPROVED"
          );
        });
      }
      return [];
    },

    approvedTasks() {
      return (
        (this.tasks &&
          this.tasks.data.filter(
            t =>
              t.status != "CLOSED" &&
              t.approval_status == "APPROVED" &&
              t.payment_status == "SUCCESS"
          )) ||
        []
      );
      //return this.tasks
    },

    closedTasks() {
      return (
        (this.tasks && this.tasks.data.filter(t => t.status == "CLOSED")) || []
      );
    },

    projectBudget() {
      let totalHours = 0;
      let totalCost = 0;
      let ts = this.openTasks || [];
      console.log("hi hi", ts);

      ts.map(t => {
        let tc = parseFloat(t.hourly_cost || 0);
        let hours = parseInt(t.quoted_hours || 0);
        totalHours += hours;

        tc = this.getTotalCostValue(t);
        totalCost += tc;
        console.log("Total cost is " + totalCost + " and tc is " + tc);
      });

      // let totalCostFormatted = ''
      // if (totalCost >= 1000) {
      //   totalCostFormatted = (totalCost / 1000).toFixed(2) + "k";
      // } else {
      //   totalCostFormatted = totalCost;
      // }
      // console.log("Total cost is "+totalCost)

      return {
        currency: this.profile && this.profile.currency.symbol,
        cost: numeral(totalCost).format(),
        costAmount: totalCost,
        hours: totalHours
      };
    },

    selectedBudget() {
      let totalHours = 0;
      let totalCost = 0;
      let ts = this.approvalSelectedTasks || [];
      console.log("hi hi", ts);

      ts.map(t => {
        let tc = parseFloat(t.hourly_cost || 0);
        let hours = parseInt(t.quoted_hours || 0);
        totalHours += hours;

        tc = this.getTotalCostValue(t);
        totalCost += tc;
        console.log("Total cost is " + totalCost + " and tc is " + tc);
      });

      // let totalCostFormatted = ''
      // if (totalCost >= 1000) {
      //   totalCostFormatted = (totalCost / 1000).toFixed(2) + "k";
      // } else {
      //   totalCostFormatted = totalCost;
      // }
      console.log("Total cost is " + totalCost);
      let bracketFee = (totalCost * 2) / 100;

      return {
        currency: this.profile && this.profile.currency.symbol,
        cost: numeral(totalCost).format(),
        costAmount: totalCost,
        hours: totalHours,
        bracketFee,
        bracketFeeFormatted: numeral(bracketFee).format()
      };
    }
  },

  watch: {
    selectAll() {
      this.$emit("selectAllClicked", this.openTasks, this.selectAll);
    }
  },

  async mounted() {
    numeral.defaultFormat("0,0");
    await this.fetchRoles();
    this._onAddNewClicked();
    // try {
    //   let res = await this.fetchProjectHistories(this.project.id)
    //   //this.histories = res
    // } catch(e) {
    //   console.log("error fetching project histories ", e);
    // }
  },
  methods: {
    ...mapActions("task", ["updateTask", "deleteTask", "createTask"]),
    ...mapActions("project", [
      "fetchProjectHistories",
      "updateProject",
      "changeApprovalStatus"
    ]),
    ...mapActions("common", ["fetchRoles"]),
    ...mapActions("user", ["connectStripe", "checkoutStripe"]),
    ...mapMutations(["setGanttRender", "setLoading"]),
    ...mapMutations("project", ["setSingleProject"]),

    userAvatar(user) {
      let avatar = "";
      let bg_colors = [
        "bg-success",
        "bg-info",
        "bg-default",
        "bg-darker",
        "bg-danger"
      ];
      let bg = "bg-success";
      let hasImage = false;
      if (user) {
        if (user.profile_pic != null) {
          avatar = user.profile_pic.file_url;
          hasImage = true;
        } else {
          hasImage = false;
          let ch =
            user.first_name && user.first_name.substring(0, 1).toUpperCase();
          bg = bg_colors[(ch.charCodeAt(0) + user.first_name.length) % 5];
          avatar =
            user.first_name &&
            user.first_name.substring(0, 1).toUpperCase() +
              (
                (user.last_name && user.last_name.substring(0, 1)) ||
                ""
              ).toUpperCase();
        }
      } else {
        avatar = "NU";
        //task_return += '<span class="mr-1"><i class="fas fa-arrow-'+task.which_task+'"></i></span>';
      }

      // <span data-toggle="tooltip" data-trigger="hover" title="No User" class="d-flex mr-1"><a href="#" class="avatar avatar-name avatar-sm  '+bg+' text-xl text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas">NU</a></span>

      return {
        hasImage: hasImage,
        avatar: avatar,
        bg: bg
      };
    },

    canEdit(task) {
      let isOwner =
        this.project.user_owner &&
        this.project.user_owner.user.id == this.profile.id;

      let isTaskOwner =
        task.assignedBy && task.assignedBy.user.id == this.profile.id;

      let isContributor = (this.project.contributors || []).some(
        c => c.user.id == this.profile.id
      );

      // console.log(
      //   "can edit task",
      //   task.approval_status != "APPROVED",
      //   isOwner,
      //   isContributor,

      //   isTaskOwner
      // );

      return (
        task.approval_status != "APPROVED" &&
        (isOwner || isContributor || isTaskOwner)
      );
    },

    canEditDescription(task) {
      let isOwner =
        this.project.user_owner &&
        this.project.user_owner.user.id == this.profile.id;

      let isContributor = (this.project.contributors || []).some(
        c => c.user.id == this.profile.id
      );

      let isApprover =
        this.project.approvers &&
        (this.project.approvers || []).some(c => c.user.id == this.profile.id);

      let isTaskOwner =
        task.assignedBy && task.assignedBy.user.id == this.profile.id;

      // console.log(
      //   "can edit description",
      //   task.approval_status != "APPROVED",
      //   isOwner,
      //   isContributor,
      //   isApprover,
      //   isTaskOwner
      // );

      return (
        task.approval_status != "APPROVED" &&
        (isOwner || isContributor || isApprover || isTaskOwner)
      );
    },

    isOverDue(task) {
      let isApprover = (this.project.approvers || []).some(
        c => c.user.id == this.profile.id
      );
      return (
        task.approval_status == "APPROVED" &&
        task.payment_status == "OVERDUE" &&
        isApprover
      );
    },

    shouldShowMenu(task) {
      let isOwner =
        this.project.user_owner &&
        this.project.user_owner.user.id == this.profile.id;

      let isContributor = (this.project.contributors || []).some(
        c => c.user.id == this.profile.id
      );

      let isContributorTask = (task.contributors || []).some(
        c => c.user.id == this.profile.id
      );

      return (
        ((task.approval_status != "APPROVED" &&
          (isOwner || isContributor || isContributorTask)) ||
          this.isOverDue(task)) &&
        task.id
      );
    },

    canDelete(task) {
      let isOwner =
        this.project.user_owner &&
        this.project.user_owner.user.id == this.profile.id;

      let isContributor = (this.project.contributors || []).some(
        c => c.user.id == this.profile.id
      );

      let isContributorTask = (task.contributors || []).some(
        c => c.user.id == this.profile.id
      );

      return (
        task.approval_status != "APPROVED" &&
        (isOwner || isContributor || isContributorTask) &&
        task.id
      );
    },

    createdAt(value) {
      return moment(value).format("DD, MMM, yyyy");
    },

    async _onContributerUsersChanged(v) {
      console.log(v, "dada");
      //return false
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
      ) {
        return false;
      }
      //add user to current project and fetch data
      try {
        let res = await this.updateProject({
          ...this.project,
          contributors: v,
          from: 'CONTRIBUTOR'
          //   asset_users: [...(this.project.asset_users || []), ...v]
        });
        this.$emit("projectUpdated", res);
        this.modals.contributors = false;
      } catch (e) {
        console.log(e, "Error updating projec t");
      }

      //this.setSingleProject({...this.project, contributors: this.contributors})
      //  alert("call api which adds contributors users to current project")
    },

    async _onApproversChanged() {
      console.log(this.project, "dada");
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
      ) {
        return false;
      }
      //add user to current project and fetch data
      //   try {
      //     let res = await this.updateProject({
      //       ...this.project
      //     });
      //     this.$emit("projectUpdated", res);
      //     this.modals.viewers = false;
      //   } catch (e) {
      //     console.log(e, "Error updating project");
      //   }

      this.saveTask(this.selectedTask);
      this.modals.approvers = false;
    },

    async _onProjectApproversChanged() {
      console.log(this.project, "dada");
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
      ) {
        return false;
      }
      // add user to current project and fetch data
      try {
        let res = await this.updateProject({
          ...this.project,
          from: 'APPROVER'
        });
        this.$emit("projectUpdated", res);
        this.modals.viewers = false;
      } catch (e) {
        console.log(e, "Error updating project");
      }

      //this.saveTask(this.selectedTask)
      this.modals.approvers = false;
    },

    async _onViewersChanged(v) {
      console.log(v, "dada");
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name == "guest"
      ) {
        return false;
      }
      //add user to current project and fetch data
      try {
        let res = await this.updateProject({
          ...this.project,
          viewers: v,
          from: 'VIEWER'
          //   asset_users: [...(this.project.asset_users || []), ...v]
        });
        this.$emit("projectUpdated", res);
        this.modals.viewers = false;
      } catch (e) {
        console.log(e, "Error updating project");
      }

      //this.setSingleProject({...this.project, contributors: this.contributors})
      //  alert("call api which adds contributors users to current project")
    },

    isApproved(task) {
      return task.approval_status == "APPROVED";
    },

    _onInvoiceClicked(task) {
      this.$emit("overDueClicked", [task]);
    },

    async _onDuplicateTaskClicked(task) {
      let t = { ...task };
      let name = "Copy Of " + t.name;
      //now find if another duplicate name exisits:
      let duplicates = this.openTasks
        .filter(t => {
          return t.name.includes(name);
        })
        .map(t => {
          let duplicateParts = t.name.split(" ");
          let duplicateIndex = parseInt(
            duplicateParts[duplicateParts.length - 1]
          );
          return duplicateIndex;
        })
        .sort((a, b) => parseInt(b) - parseInt(a));

      if (duplicates.length > 0) {
        name = name + " " + (duplicates[0] + 1);
      }

      t.approval_status = "QUOTED";
      t.payment_status = "PENDING";
      t.id = null;
      t.approvedBy = null;
      t.invoicedBy = null;

      if (t.discount_percentage == "N/A") {
        t.discount_percentage = 0;
      }

      try {
        let res = await this.createTask(t);
        task.id = res.data.id;
        //await this.fetchTask(this.task.id)
        //await this.fetchTask(task.id, refresh);
        //this._onAddNewClicked();
        this.setGanttRender();
        saving = false;
        this.$emit("taskCreated", true);
        this.scrollToBottom();

        //this.$snack.success("Task Has been updated successfully");
      } catch (e) {
        saving = false;
        console.log("Erro task duplicate ", e);
        this.$snack.success("Error occured while duplicating task");
      }
    },

    scrollToBottom() {
      let element = document.getElementById("container-scroll");
      element.scrollIntoView({ behavior: "smooth", block: "end" });
    },

    _onAddNewClicked() {
      let t = this.openTasks || [];
      if (t.length > 0) {
        if (this.openTasks.some(t => t.id == null)) return;
      }
      let role = this.roles.filter(r => r.name == "CREATOR")[0];
      let assigneeRole = this.roles.filter(r => r.name == "ASSIGNEE")[0];
      let assigner = { ...this.profile };

      let task = {
        id: null,
        assignedBy: { user: assigner, asset_role: role },
        assignedTo: { user: assigner, asset_role: assigneeRole },
        name: "",
        comments: [],
        csu: [],
        cc: [],
        mbs_months: 1,
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        quoted_hours: 0,
        no_of_days: 1,
        approvers: [],
        discount_percentage: "N/A",
        hourly_cost: null,
        status: "OPEN",
        approval_status: "QUOTED"
      };

      this.newTasks = [
        //...this.newTasks,

        task
      ];
    },

    async _onStripeConnectClicked() {
      try {
        let res = await this.connectStripe();
        localStorage.setItem("stripe_connect_project", this.project.id);
        console.log("Stripe connect ", res);
        window.location.href = res.redirect_url;
      } catch (e) {
        console.log("Error fetching stripe connect", e);
      }
    },

    _onDescriptionBlur(task) {
      if (task.id) {
        alert(task.id);
        this.saveTask(task, false);
      } else {
        //alert(his.getTotalCostValue(task))
        if (this.getTotalCostValue(task) > 0) {
          this.saveTask(task, false);
        }
      }
    },

    _onTitleBlur(task) {
      this.placeholder = "+ New Requirement";
      if (task.id) {
        this.saveTask(task, false);
      } else {
        if (this.getTotalCostValue(task) > 0) {
          this.saveTask(task, false);
        }
      }
    },

    _onDescriptionBlur(task) {
      if (task.id) {
        this.saveTask(task, false);
      } else {
        if (this.getTotalCostValue(task) > 0) {
          this.saveTask(task, false);
        }
      }
    },

    _updateTask(task) {
      if (task.id) {
        this.saveTask(task, false);
      } else {
        if (this.getTotalCostValue(task) > 0) {
          this.saveTask(task, false);
        }
      }
    },

    onRateSelected(r) {
      //alert(r.rate)
      console.log(this.editIndex);
      this.openTasks[this.editIndex].hourly_cost = r.rate;
      this.showRates = false;

      if (this.openTasks[this.editIndex].id) {
        this.saveTask(this.openTasks[this.editIndex]);
      } else {
        if (this.getTotalCostValue(this.openTasks[this.editIndex]) > 0) {
          this.saveTask(this.openTasks[this.editIndex], false);
        }
      }
    },

    async saveTask(task, refresh = true) {
      console.log("saving");
      if (
        saving == true ||
        (this.profile && this.profile.role && this.profile.role.name == "guest")
      ) {
        return false;
      }
      saving = true;
      task.parent_id = this.project.id;
      if (!task.name || task.name == "") {
        this.$snack.success("Task Name can't be empty");
        saving = false;
        return;
      }

      if (!task.hourly_cost || task.hourly_cost == "") {
        this.$snack.success("Per hour rate can't be empty");
        saving = false;
        return;
      }

      let body = { ...task };

      if (this.profile.quoteCalculationInterval == "HOUR") {
        body.no_of_days = (parseInt(body.quoted_hours) / 8).toFixed(1);
      } else {
        body.quoted_hours = parseInt(body.no_of_days) * 8;
      }

      if (body.discount_percentage == "N/A") {
        body.discount_percentage = 0;
      }

      if (body.total_team_members == null || body.total_team_members == 0) {
        body.total_team_members = 1;
      }

      if (body.id) {
        try {
          let res = await this.updateTask(body);

          //await this.fetchTask(this.task.id)
          //await this.fetchTask(task.id, refresh);
          this.setGanttRender();
          saving = false;
          this.$emit("taskCreated", refresh);

          //this.$snack.success("Task Has been updated successfully");
        } catch (e) {
          saving = false;
          console.log("Error task save ", e);
          this.$snack.success("Error occured while updating task");
        }
      } else {
        try {
          let res = await this.createTask(body);

          task.id = res.data.id;

          //await this.fetchTask(this.task.id)
          //await this.fetchTask(task.id, refresh);
          //this._onAddNewClicked();
          this.setGanttRender();
          saving = false;
          this.$emit("taskCreated", refresh);

          //now reset new task after saving
          let role = this.roles.filter(r => r.name == "CREATOR")[0];
          let assigneeRole = this.roles.filter(r => r.name == "ASSIGNEE")[0];
          let assigner = { ...this.profile };

          let t = {
            id: null,
            assignedBy: { user: assigner, asset_role: role },
            assignedTo: { user: assigner, asset_role: assigneeRole },
            name: null,
            comments: [],
            csu: [],
            cc: [],
            mbs_months: 1,
            start_date: moment().format("YYYY-MM-DD"),
            end_date: moment().format("YYYY-MM-DD"),
            quoted_hours: 1,
            no_of_days: 1,
            mbs_months: 1,
            approvers: [],
            discount_percentage: "N/A",
            hourly_cost: null,
            status: "OPEN",
            approval_status: "QUOTED"
          };

          this.newTasks = [t];
          //this.$snack.success("Task Has been updated successfully");
        } catch (e) {
          saving = false;
          console.log("Erro task save ", e);
          this.$snack.success("Error occured while updating task");
        }

        saving = false;
      }
    },

    async _onAddApproverClicked(task) {
      if (await this.isApproverForTheTaskOrProject(task)) {
        // this.$emit('approveClicked', task)
      } else {
        this.selectedTask = task;
        this.modals.approvers = true;
      }

      this.selectedTask = task;
      this.modals.approvers = true;
    },

    _onNewRequirementClicked() {
      this.selectedTask = null;
      this.showRequirement = true;
    },

    async _onAcceptClicked() {
      try {
        let res = await this.changeApprovalStatus({
          id: this.project.id,
          approval_status: "APPROVED"
        });

        this.$snack.success("Accepted Successfully");
        this.$emit("approveSuccess");
      } catch (e) {
        console.log(e);
        this.$snack.success("Error accepting approval request");
      }
    },

    _onApproveClicked() {
      localStorage.setItem(
        "approvalTasks",
        JSON.stringify(this.approvalSelectedTasks)
      );
      this.$emit("approveClicked", this.approvalSelectedTasks);
    },

    _onDeleteTaskClicked(task) {
      swal({
        title: "Are you sure to delete this task?",
        text: `Please click Yes to proceed!`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteSelectedTask(task, true);
        }
      });
    },

    async deleteSelectedTask(task, refresh = true) {
      task.parent_id = this.project.id;
      if (task.id) {
        if (
          this.profile &&
          this.profile.role &&
          this.profile.role.name != "guest"
        ) {
          try {
            let res = await this.deleteTask(task);
            //await this.fetchTask(this.task.id)
            //await this.fetchTask(task.id, refresh);

            this.$emit("taskDeleted", refresh);
            //this.$emit("taskCreated", refresh);
            saving = false;
            //this.$snack.success("Task Has been updated successfully");
          } catch (e) {
            saving = false;
            console.log("Erro task update ", e);
            this.$snack.success("Error occured while deleting task");
          }
        } else {
          this.$snack.success("You can not delete task on guest mode");
        }
      }
    },

    closePopOver(event) {
      let el = event.target.closest(".el-popover");
      $(el).css("display", "none");
    },

    getTotalCost(task) {
      let totalHours = 0;
      let totalCost = 0;
      let t = task || {};

      totalCost = parseFloat(t.hourly_cost || 0);
      totalHours = parseInt(t.quoted_hours || 0);
      let dp = isNaN(parseInt(t.discount_percentage))
        ? 0
        : parseInt(t.discount_percentage);

      dp = 0; //for now make 0 as no ui for this

      const numOfDays = parseInt(t.no_of_days || 1);
      const teamSize = parseInt(t.total_team_members || 1);
      if (this.profile.quoteCalculationInterval == "HOUR") {
        totalCost = totalCost * totalHours * teamSize;
      } else {
        totalCost = totalCost * (numOfDays * 8) * teamSize;
      }
      totalCost = totalCost * parseInt(t.mbs_months);
      totalCost = totalCost - (totalCost * dp) / 100;
      if (isNaN(totalCost)) totalCost = 0;
      // totalCost = totalCost.toFixed(2);

      // if (totalCost >= 1000) {
      //   totalCost = (totalCost / 1000).toFixed(2) + "k";
      // }

      let gst = (totalCost * 10) / 100;
      let netTotal = totalCost + gst;

      let currency = this.profile && this.profile.currency.symbol;
      return {
        currency: currency,
        costFormatted: currency + numeral(totalCost).format(),
        cost: totalCost,
        gst: gst,
        gstFormatted: currency + numeral(gst).format(),
        netTotal: netTotal,
        netTotalFormatted: currency + numeral(netTotal).format()
      };
    },

    getTotalCostValue(task) {
      let totalHours = 0;
      let totalCost = 0;
      let t = task || {};

      totalCost = parseFloat(t.hourly_cost || 0);
      totalHours = parseInt(t.quoted_hours || 0);
      let dp = isNaN(parseInt(t.discount_percentage))
        ? 0
        : parseInt(t.discount_percentage);

      dp = 0; //for now make 0 as no ui for this

      const numOfDays = parseInt(t.no_of_days || 1);
      const teamSize = parseInt(t.total_team_members || 1);
      if (this.profile.quoteCalculationInterval == "HOUR") {
        totalCost = totalCost * totalHours * teamSize;
      } else {
        totalCost = totalCost * (numOfDays * 8) * teamSize;
      }
      totalCost = totalCost * parseInt(t.mbs_months);
      totalCost = totalCost - (totalCost * dp) / 100;
      if (isNaN(totalCost)) totalCost = 0;
      //totalCost = totalCost.toFixed(2);

      return totalCost;
    },

    getQuotedText(task) {
      let qt = task.quoted_text || "Add Description";

      return (
        qt.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 15) + "..." ||
        "Item Description"
      );
    },

    getQuotedTextExcerpt(task, short) {
      let qt = task.quoted_text || "";

      qt = qt.replace(/<\/?[^>]+(>|$)/g, "");
      if (qt.length >= 60) {
        return qt.substring(0, 60) + "...";
      }

      return qt.substring(0, 60);
    },

    isApproverForTheTaskOrProject(task) {
      return (
        task.approvers.some(c => c.user.id == this.profile.id) ||
        this.project.approvers.some(c => c.user.id == this.profile.id)
      );
    },

    onFilterChanged() {}
  }
};
</script>

<style lang="css">
.select-small.el-select .el-input .el-input__inner {
  height: 31px;
}

.custom-radio .custom-control-input ~ .custom-control-label {
  line-height: 1.7rem;
}

.select-border-0.el-select .el-input .el-input__inner {
  border: transparent;
}

.select-border-0.el-select .el-input__suffix {
  display: none;
}

/* .table td {
    padding: 0.3rem;
} */
</style>

<style lang="scss" scoped>
.sm-gantt_task_line {
  height: 31px !important;
  line-height: 31px !important;

  .gantt_task_content {
    font-size: 13px;
    line-height: 31px;
  }
}

.media-body {
  .btn-sm {
    padding: 0.344rem 0.5rem !important;
  }
}

.total-price {
  h2 {
    font-size: 0.875rem !important;
    margin-bottom: 0;
  }
}

.close-btn-wrap {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 25px;

  button {
    background: transparent;
    border: 0;
    padding: 0;

    i {
      color: #2dce89;
    }

    &:hover {
      opacity: 0.5;
    }
  }
}

.mobile-view-table {
  margin-bottom: 0;
  border-bottom: 1px solid #e9ecef;

  tbody.list {
    tr {
      th.project {
        white-space: pre-wrap;
      }

      td.edit {
        width: 40px;
      }
    }
  }
}

.ul-tasks-edit {
  padding: 15px;
  padding-bottom: 0;

  li {
    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &.wrap {
      input {
        height: calc(0.45em + 1.25rem + 17px);
      }

      li {
        flex: 0 0 50%;
        max-width: 50%;

        &:first-child {
          padding-right: 5px;
        }

        &:last-child {
          padding-left: 5px;
        }
      }
    }

    label {
      font-weight: 500;
      margin-bottom: 2px;
    }
  }
}

.expand-quote-text {
  white-space: break-spaces;
  white-space: normal;
}

@media only screen and (max-width: 768px) {
  .ul-tasks-edit {
    li.wrap {
      input {
        height: calc(0.45em + 1.25rem + 16px);
      }
    }
  }
}
</style>
